import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/export-duck";
import { UserExport } from "interfaces/user-export"; 

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "EXPORT_USERS_" }
);

export interface ExportUsersState extends IState {
  data: UserExport[];
}

interface ISuccessExportUsersAction extends ISuccessAction {
  data: UserExport[];
}

const INITIAL_STATE: ExportUsersState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ExportUsersState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ExportUsersState, action: ISuccessExportUsersAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ExportUsersState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const exportUsers = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ExportUsersTypes = Types;
export const ExportUsersActions = Creators;
